import { registerNamespaces } from "@/lib/i18n/dictionary";

import enBlogPage from "@/locales/en/blogPage.json";
import thBlogPage from "@/locales/th/blogPage.json";

/**
 * Registers the `blogPage` namespace for /blog, /blog/[slug] and
 * /blog/tag/[tag].
 *
 * A plain module, so the server-side `generateMetadata` of each blog route can
 * import it for its side effect and look strings up before React renders. The
 * cards, headers and share row are client components, so `BlogI18n` (blog.tsx)
 * imports this same file again to keep the registration in the client chunk.
 *
 * main had three identical copies of this, one per route; they only ever
 * registered the same namespace, so one is enough.
 */
registerNamespaces({
  en: { blogPage: enBlogPage },
  th: { blogPage: thBlogPage },
});
